<div class="glass-card border border-white border-opacity-10 p-3 rounded-4 mb-3">
    <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">
        <div>
            <div class="d-flex flex-wrap align-items-center gap-2 mb-2">
                <h4 class="text-white fw-bold mb-0">User Management</h4>
                <span class="badge rounded-pill text-bg-secondary bg-opacity-25 border border-light border-opacity-10">{{ users_count }} users</span>
                <span class="badge rounded-pill text-bg-success bg-opacity-25 border border-success border-opacity-25">{{ active_users_count }} active</span>
            </div>
            <p class="text-white-50 mb-0 text-sm">
                Add users, update their roles, and manage account access.
            </p>
        </div>

        <button
            type="button"
            class="btn btn-primary btn-sm rounded-3 d-inline-flex align-items-center gap-1 px-3"
            @click="$emit('open-add-user')"
        >
            <i class="bi bi-person-plus-fill fs-6"></i>
            <span class="text-xs">Add user</span>
        </button>
    </div>
</div>
